import { AfterViewInit, Component, OnInit } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import Swal from "sweetalert2";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { Utilities } from 'src/app/models/utilities';
import { VendorService } from "src/app/services/vendor.service";
import { CustomerService } from "src/app/services/customer.service";
import { RateUploadService } from "src/app/services/operations/rateupload.service";
import { RateBandsService } from "src/app/services/ratebands.service";
import { ColumnApi, GridApi, GridOptions, GridReadyEvent } from "ag-grid-community";
import { EditDeleteActionsRenderer } from "../../../shared/ag-grid/cell-renderers/edit-delete.component";
import { EditViewDeleteActionsRenderer } from "src/app/components/shared/ag-grid/cell-renderers/delete-view.component";
import { saveAs } from 'file-saver-es';
import { FileHandlerService } from "src/app/services/file-handler.service";
import { HttpHeaders } from "@angular/common/http";
import { AppCoreService } from "src/app/services/app-core.service";
import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { RateDetailsComponent } from "./details/ratedetails.component";
import { RatePeriodComponent } from "./periods/rateperiod.component";
import { lastValueFrom } from "rxjs";
import { Title } from "@angular/platform-browser";
import { ExcelService } from "src/app/services/excel.service";

@Component({
  selector: 'app-rateupload',
  templateUrl: './rateupload.component.html',
  styleUrls: ['./rateupload.component.scss'],
})
export class RateUploadComponent implements OnInit, AfterViewInit {
  rateUploadForm: FormGroup;
  permConfig = {
    isViewAllowed: false,
    isAddAllowed: false,
    isEditAllowed: false,
    isDeleteAllowed: false
  };
  ngbModalOptions: NgbModalOptions = {
    ariaLabelledBy: 'modal-basic-title',
    size: 'lg',
    backdrop: 'static',
    keyboard: false,
    centered: true
  };
  isFormSubmitted: boolean;
  showPeriodModal: boolean;
  showRateModal: boolean;

  showCategory = false;
  rateTypeList = [];
  rateCategoriesList = [];
  rateCategories = [];
  //rateCategory = [{ id: 1, category: "Customer" }, { id: 2, category: "Vendor" }]
  ratecategorytypeList = [{ name: "Standard", value: "Standard", ratefilepath: "" }, { name: "Zone Rate", value: "Zone Rate", ratefilepath: "rates/contract/ZoneRates.xlsx" }, { name: "Country Rate", value: "Country Rate", ratefilepath: "rates/contract/CountryRates.xlsx" }]
  rateList: any[] = []
  rateBandList: []
  vendorList: any[] = [];
  customerList: any[] = [];
  // originList: any;
  // destinationList: any;
  // rateCategoryCode: any;
  periodData: any;
  rateDetailData: any;
  ratePeriodId: number;
  showDownloadBtn = false;
  showBands = false;
  showCustomer = false;
  showVendor = false;
  selectedFile: File | null = null;
  showRateDetails = false;

  showProgressBar = false;
  progress: number = 0;

  public context: any;
  private gridApi!: GridApi;
  private gridColumnApi!: ColumnApi;
  periodId: number; //ratePeriod table serial id 

  defaultColDef = {
    filter: true,
    sortable: true,
    resizable: false,
    flex: 1,
    minWidth: 120
  };

  gridOptionsPeriod: GridOptions = {
    pagination: true,
    domLayout: 'autoHeight',
    paginationPageSize: 5
  }
  gridOptions: GridOptions = {
    pagination: true,
    domLayout: 'autoHeight',
    paginationPageSize: 10
  }
  rowDataInfo: any[] = [];
  rowDataPeriod = [];
  columnDefsPeriod = [
    { headerName: 'Rate Type', field: 'ratetype' },
    { headerName: 'Category', field: 'ratecategory' },
    { headerName: 'From Date', field: 'fromdate' },
    { headerName: 'To Date', field: 'todate' },
    { headerName: 'Band', field: 'rateband' },
    { headerName: 'Customer', field: 'customer' },
    { headerName: 'Vendor', field: 'vendor' },
    {
      headerName: 'Actions',
      field: 'id',
      cellRenderer: EditViewDeleteActionsRenderer,
      cellClass: "actions-button-cell",
      cellStyle: { "overflow": 'visible' },
      colId: 'params',
      editable: false,
      sortable: false,
      filter: false,
      minWidth: 100,
    },
  ];
  columnDefs = [
    { headerName: 'Product', field: 'productname', maxWidth: 170, pinned: 'left' },
    { headerName: 'Vendor', field: 'vendorname', pinned: 'left' },
    { headerName: 'Service', field: 'servicename', pinned: 'left' },
    { headerName: 'Origin Country', field: 'origincountry' },
    { headerName: 'Origin State', field: 'originstate' },
    { headerName: 'Origin City', field: 'origincity' },
    { headerName: 'Zone', field: 'zonecode' },
    { headerName: 'Destination Country', field: 'destinationcountry', minWidth: 170 },
    { headerName: 'Destination State', field: 'destinationstate', minWidth: 160 },
    { headerName: 'Destination City', field: 'destinationcity', minWidth: 150 },
    { headerName: 'Rate Type', field: 'ratetype' },
    { headerName: 'Weight', field: 'weight', minWidth: 90 },
    { headerName: 'Rate', field: 'rate', minWidth: 80, pinned: 'right' },
    { headerName: 'Unit', field: 'rateunit', minWidth: 70, pinned: 'right' },
    {
      headerName: 'Actions',
      field: 'id',
      cellRenderer: EditDeleteActionsRenderer,
      cellClass: "actions-button-cell",
      cellStyle: { "overflow": 'visible' },
      colId: 'params',
      editable: false,
      filter: false,
      sortable: false,
      minWidth: 100,
      pinned: 'right'
    },
  ];
  currentDate: any;
  useEnterKey: any;

  constructor(
    private formBuilder: FormBuilder,
    private ngxLoaderService: NgxUiLoaderService,
    private utilities: Utilities,
    private appCoreService: AppCoreService,
    private customerService: CustomerService,
    private vendorService: VendorService,
    private rateUploadService: RateUploadService,
    private rateBandsService: RateBandsService,
    private fileHandlerService: FileHandlerService,
    public modalService: NgbModal,
    private rateService: RateUploadService,
    private titleService: Title,
    private excelService: ExcelService
  ) {
    titleService.setTitle('Rate Upload');
    this.context = { componentParent: this, actionConfig: { update: true } };
  }

  ngOnInit(): void {
    // set full width for this page 
    const bodyTag = document.body;
    bodyTag.classList.add('sidebar-enable')
    bodyTag.classList.add('vertical-collpsed');

    this.currentDate = this.utilities.FormatDateWithTime();
    this.rateUploadForm = this.formBuilder.group({
      ddlRateType: [null, Validators.required],
      ddlRateCategory: [null, Validators.required],
      ddlRateBand: [null, Validators.required],
      ddlCustomer: [null, Validators.required],
      ddlVendor: [null, Validators.required],
      ddlType: ["Standard", Validators.required],
      txtFromDate: [this.currentDate.dateString, Validators.required],
      txtToDate: [this.currentDate.dateString, Validators.required],
      fileControl: [null, Validators.required],
    });
    this.checkPermission();
    if (this.permConfig.isViewAllowed) {
      this.getAllRateTypes();
      this.getAllRatePeriod();
    }
    this.getAllRateBands(); //call them in init --> to be modified lateron on rateTpe change
    this.getAllCustomers();
    this.getAllVendors();

  };

  ngAfterViewInit(): void {
    this.useEnterKey ? this.utilities.focusFirstElement(this.rateUploadForm) : null;
  }

  checkPermission(): any {
    const userData = this.appCoreService.GetUserData();
    this.useEnterKey = !userData.metaInfo.tabbasedtemplate;
    const permission = userData.config.filter(x => x.categoryname === 'Upload');
    if (permission.length) {
      this.permConfig.isViewAllowed = permission[0].view;
      this.permConfig.isAddAllowed = permission[0].add;
      this.permConfig.isEditAllowed = permission[0].edit;
      this.permConfig.isDeleteAllowed = permission[0].delete;
    }
  }


  getAllRateTypes() {
    this.rateUploadService.GetAllRateTypes().subscribe(res => {
      try {
        if (res && res.success) {
          let i = 0;
          this.rateTypeList = res.data.types;
          this.rateCategoriesList = this.rateCategories = res.data.categories;

          this.rateCategoriesList = this.rateCategoriesList.filter(
            (item) => item.ratecategory !== 'Country Rate' && item.ratecategory !== 'Zone Rate'
          );
          // console.log('rateCategoriesList',this.rateCategoriesList);
          // const rateCategory: any[] = this.rateCategoriesList.filter(x => x.ratecategory == "Customer" || x.ratecategory == "Vendor")
          //   .map((x, i) => ({ "id": i + 1, "category": x.ratecategory }));
          // let rateFormats: any[] = this.rateCategoriesList.filter(x => x.ratecategory != "Customer" && x.ratecategory != "Vendor");

          // rateFormats.push({ ratecategory: "Standard", id: -1 });

          // rateCategory.map((item) => {
          //   rateFormats.map((data) => {
          //     this.rateList.push({ ...data, category: item.category, value: `${item.category}-${data.ratecategory}` });
          //   });
          // });

          // this.rateCategoriesList = this.rateList;
          // console.log('rateCategoriesList', this.rateCategoriesList);

          // this.rateUploadForm.get('ddlRateCategory').setValue(this.rateCategoriesList[0].id);

        }
      } catch (error) {
        console.error(error);
      }
    })
  }

  getAllRateBands() {
    try {
      this.rateBandsService.GetAll().subscribe((res) => {
        if (res && res.success) {
          this.rateBandList = res.data;
        }
      })
    } catch (error) {
      console.error(error);
    }
  }

  getAllCustomers() {
    try {
      this.customerService.GetAll({ scid: this.appCoreService.GetUserData().selectedServiceCenter, isactive: true }).subscribe((res) => {
        if (res) {
          this.customerList = res.data;
        }
      })
    } catch (error) {
      console.error(error);
    }

  }

  checkCustContract() {
    try {
      const customerid = this.rateUploadForm.get('ddlCustomer').value
      const rate = this.rateUploadForm.get('ddlRateType').value

      this.customerService.getContractDetailbyCustId(customerid).subscribe((res) => {
        if (res) {
          this.customerList = res.data;

          const formattedData = this.customerList.map(item => ({
            ...item,
            fromdate: this.utilities.formatDate(item.fromdate).dateString,
            todate: this.utilities.formatDate(item.todate).dateString
          }));

          const today = new Date();
          const customerContracts = formattedData.filter(contract =>
            contract.customerid === customerid && new Date(contract.fromdate) <= today
          );
          this.rateUploadForm.get('txtFromDate').setValue(customerContracts[0].fromdate);
          this.rateUploadForm.get('txtToDate').setValue(customerContracts[0].todate);
          this.rateUploadForm.get('txtFromDate').disable();
          this.rateUploadForm.get('txtToDate').disable();
        }
      })

    } catch (error) {
      console.error(error);
    }
  }

  getAllVendors() {
    try {
      this.vendorService.GetAll({ isactive: true }).subscribe((res) => {
        if (res && res.success) {
          this.vendorList = res.data;
        }
      })
    } catch (error) {
      console.error(error);
    }
  }

  getAllRatePeriod(refresh = false) {
    this.ngxLoaderService.start();
    this.rateUploadService.GetAllRatePeriods({refresh : refresh}).subscribe(res => {
      try {
        if (res?.success && res.data) {
          this.ngxLoaderService.stop();
          this.rowDataPeriod = res.data;
          // console.log(res.data);
        } else if (res?.success) {
          this.ngxLoaderService.stop();
        }
      } catch (error) {
        this.ngxLoaderService.stop();
      }
    })


  }

  onChangeRateType() {
    //apply chargeType for - alluploadTypes
    this.rateUploadForm.controls.ddlRateBand.clearValidators();
    this.rateUploadForm.controls.ddlRateCategory.clearValidators();
    this.rateUploadForm.controls.ddlCustomer.clearValidators();
    this.rateUploadForm.controls.ddlVendor.clearValidators();
    if (this.rateUploadForm.controls.ddlRateType.value === 1) {
      // Tariff
      this.showCategory = false;
      this.showDownloadBtn = true;
      this.showBands = false;
      this.showCustomer = false;
      this.showVendor = false;
      this.rateUploadForm.controls.ddlRateCategory.reset();
      this.rateUploadForm.controls.ddlRateCategory.disable();
      this.rateUploadForm.controls.ddlRateBand.reset();
      this.rateUploadForm.controls.ddlCustomer.reset();
      this.rateUploadForm.controls.ddlVendor.reset();
      this.isFormSubmitted = false;

    } else if (this.rateUploadForm.controls.ddlRateType.value === 2) {
      // rate bands
      this.showCategory = false;
      this.showDownloadBtn = true;
      this.showBands = true;
      this.showCustomer = false;
      this.showVendor = false;
      this.rateUploadForm.controls.ddlRateBand.setValidators([Validators.required]);
      //this.rateUploadForm.controls.ddlVendor.clearValidators();
      //this.rateUploadForm.controls.ddlRateCategory.clearValidators();
      this.rateUploadForm.controls.ddlRateCategory.reset();
      this.rateUploadForm.controls.ddlRateCategory.disable();
      //this.rateUploadForm.controls.ddlVendor.clearValidators();
      this.rateUploadForm.controls.ddlVendor.reset();
      //this.rateUploadForm.controls.ddlCustomer.clearValidators();
      this.rateUploadForm.controls.ddlCustomer.reset();

      this.isFormSubmitted = false;
    } else if (this.rateUploadForm.controls.ddlRateType.value === 3) {
      // Contract
      this.showCategory = true;
      this.showDownloadBtn = true;
      this.showBands = false;
      this.rateUploadForm.controls.ddlRateCategory.enable();
      this.rateUploadForm.controls.ddlRateCategory.setValidators([Validators.required]);
      //this.rateUploadForm.controls.ddlRateBand.clearValidators();
      //this.rateUploadForm.controls.ddlVendor.clearValidators();
      //this.rateUploadForm.controls.ddlCustomer.clearValidators();

      this.rateUploadForm.controls.ddlRateBand.reset();
      this.rateUploadForm.controls.ddlVendor.reset();
      this.rateUploadForm.controls.ddlCustomer.reset();

      this.isFormSubmitted = false;
    } else {
      this.showDownloadBtn = false;
      this.showBands = false;
      this.showCustomer = false;
      this.showVendor = false;
    }
    this.rateUploadForm.controls.ddlRateCategory.updateValueAndValidity();
    this.rateUploadForm.controls.ddlCustomer.updateValueAndValidity();
    this.rateUploadForm.controls.ddlVendor.updateValueAndValidity();
    this.rateUploadForm.controls.ddlRateBand.updateValueAndValidity();
  }

  onChangeRateCategory() {
    const selectedCategoryid = this.rateUploadForm.get('ddlRateCategory')?.value;
    // const rateCategory = selectedCategory?.split('-');
    // const group = rateCategory[0];
    //console.log('selectedCategory: ', this.rateUploadForm.get('ddlRateCategory'));

    this.showBands = false;
    if (selectedCategoryid === 1) {
      // Customer
      this.showCustomer = true;
      this.showVendor = false;
      this.rateUploadForm.controls.ddlVendor.reset();
      this.rateUploadForm.controls.ddlVendor.clearValidators();
      this.rateUploadForm.controls.ddlCustomer.setValidators([Validators.required]);

    } else if (selectedCategoryid === 2) {
      // Vendor
      this.showCustomer = false;
      this.showVendor = true;
      this.rateUploadForm.controls.ddlCustomer.reset();
      this.rateUploadForm.controls.ddlCustomer.clearValidators();
      this.rateUploadForm.controls.ddlVendor.setValidators([Validators.required]);
    } else {
      this.showCustomer = false;
      this.showVendor = false;
    }

    this.rateUploadForm.controls.ddlCustomer.updateValueAndValidity();
    this.rateUploadForm.controls.ddlVendor.updateValueAndValidity();
  }

  downloadFormatFile() {
    try {
      const fileDomainURL = this.utilities.getS3DownloadURL();
      let fileName = '';
      let downloadFileURL = '';
      const selectedRateType = this.rateUploadForm.get('ddlRateType').value;
      const selectedRateCategory = this.rateUploadForm.get('ddlRateCategory').value || "";
      const category = this.rateUploadForm.get('ddlType').value || "";
      if (selectedRateType) {
        let filePath = '';
        if (selectedRateType === 1) {
          if (category == "Standard") {
            filePath = this.rateTypeList.filter(x => x.id === selectedRateType)[0]?.ratesfilepath;
          } else {
            const selectedItem = this.ratecategorytypeList.find(item => item.value === category);
            filePath = selectedItem ? selectedItem.ratefilepath : '';
          }
        } else if (selectedRateType === 2) {
          if (category == "Standard") {
            filePath = this.rateTypeList.filter(x => x.id === selectedRateType)[0]?.ratesfilepath;
          } else {
            const selectedItem = this.ratecategorytypeList.find(item => item.value === category);
            filePath = selectedItem ? selectedItem.ratefilepath : '';
          }
        } else if (selectedRateType === 3) {
          if (category == "Standard") {
            filePath = this.rateCategories.filter(x => x.id === selectedRateCategory)[0]?.ratesfilepath;
          }
          else {
            const selectedItem = this.ratecategorytypeList.find(item => item.value === category);
            filePath = selectedItem ? selectedItem.ratefilepath : '';
          }
        }
        if (filePath) {
          fileName = filePath.substring(filePath.lastIndexOf('/') + 1);
        }
        downloadFileURL = `${fileDomainURL}${filePath}`;

      } else {

      }
      saveAs(downloadFileURL, fileName);

    } catch (e) {
      console.log(e);
    }
  }

  onChangeFileSelect(evt) {
    try {
      if (evt) {
        this.selectedFile = evt.target.files[0];
      }
    } catch (e) {
      console.error(e);
    }
  }


  async processRates(fileId: string, periodIds: any) {
    try {
      const { controls } = this.rateUploadForm;
      const fromDate = controls.txtFromDate.value;
      const toDate = controls.txtToDate.value;
      const selectedRateCategoryId = controls.ddlRateCategory.value;
      const rateCategory = this.rateCategories.find(x => x.id === selectedRateCategoryId);

      const requestObj = {
        fileId,
        periodids: periodIds,
        ratetypeid: controls.ddlRateType.value,
        ratecategoryid: rateCategory?.id,
        fromdate: fromDate,
        todate: toDate,
        rateband: controls.ddlRateBand.value,
        customer: controls.ddlCustomer.value,
        vendor: controls.ddlVendor.value,
        rateformat: controls.ddlType.value,
      };

      const res = await lastValueFrom(this.rateUploadService.UploadRate(requestObj));

      if (res) {
        if (res.success) {
          this.isFormSubmitted = false;
          this.rateUploadForm.reset();
          (document.getElementById('importrates') as HTMLInputElement).value = '';
          this.appCoreService.showMessage('Record Updated successfully');
          this.getAllRatePeriod();
          this.ngxLoaderService.stop();
        } else if (!res.success) {
          this.ngxLoaderService.stop();
          if (res.data) {
            this.warningExcelDialog(res.message, res?.data);
          } else {
            this.appCoreService.showMessage(res?.message, 'Error', 'error');
          }
        }
      }
    } catch (e) {
      console.error(e);
      this.ngxLoaderService.stop();
    }
  }

  //to upload data to into DB
  async uploadRates() {
    this.isFormSubmitted = true;
    if (!this.permConfig.isAddAllowed) {
      this.warningDialog('No Access to Add.');
      return;
    }

    if (this.rateUploadForm.valid && this.permConfig.isAddAllowed && this.selectedFile) {
      const rateTypeId = this.rateUploadForm.get('ddlRateType').value;
      const selectedRateCategory = this.rateUploadForm.get('ddlRateCategory').value || "";
      const rateCategory = this.rateCategories.find(x => x.id === selectedRateCategory);
      const rateCategoryId = rateCategory?.id;
      const selectedRateTypeText = this.rateTypeList.find(x => x.id === rateTypeId)?.ratetype;

      const rateRequestObj = {
        fromdate: this.rateUploadForm.get('txtFromDate').value,
        todate: this.rateUploadForm.get('txtToDate').value,
        ratetypeid: rateTypeId,
        ratecategoryid: rateCategoryId,
        rateformat: rateCategory?.ratecategory,
        customer: this.rateUploadForm.get('ddlCustomer').value,
        vendor: this.rateUploadForm.get('ddlVendor').value
      };

      // Initialize progress bar
      this.showProgressBar = true;
      this.progress = 0;
      const interval = setInterval(() => {
        if (this.progress < 99) this.progress++;
        setTimeout(() => {
          if (this.progress >= 99) {
            this.appCoreService.showMessage('Error in upload. Please try again later.', 'Error', 'error');
            stopProgress(interval);
          }
        }, 5000);
      }, 100);

      this.ngxLoaderService.start();
      const requestObj = { name: this.selectedFile.name, fileType: this.selectedFile.type, category: selectedRateTypeText };

      // First, get signed URL
      this.fileHandlerService.GetSignedURLForUpload(requestObj).subscribe({
        next: (res) => {
          if (res?.success && res.data.uploadURL) {
            const { uploadURL: signedUrl, fileId } = res.data;

            // Then, upload the file
            this.fileHandlerService.UploadFile(signedUrl, this.selectedFile, new HttpHeaders({ "Content-Type": requestObj.fileType })).subscribe({
              next: (f) => {
                if (f !== null) {
                  // Upload complete
                  this.fileHandlerService.UploadComplete({ id: fileId }).subscribe({
                    next: (uploadCompleteRes) => {
                      if (uploadCompleteRes?.success) {
                        // Check rate period after successful upload
                        this.rateService.CheckRatePeriod(rateRequestObj).subscribe({
                          next: async (_res) => {
                            if (_res?.data) {
                              await this.processRates(fileId, _res.data);
                              stopProgress(interval); // Stop progress here
                            }
                          },
                          error: (err) => {
                            console.error(err);
                            stopProgress(interval);
                          }
                        });
                      }
                    },
                    error: (err) => {
                      console.error(err);
                      stopProgress(interval);
                    }
                  });
                }
              },
              error: (err) => {
                console.error(err);
                stopProgress(interval);
              }
            });
          } else {
            stopProgress(interval);
          }
        },
        error: (err) => {
          console.error(err);
          stopProgress(interval);
        }
      });

    } else {
      this.showProgressBar = false;
      this.progress = 0;
      console.log('No file selected');
    }

    // Centralized cleanup function
    function stopProgress(interval) {
      clearInterval(interval);
      this.ngxLoaderService.stop();
      this.showProgressBar = false;
      this.progress = 0;
    }
  }

  checkAWBExitsToRateUpdate(input: any) {
    let reqobj = {
      fromdate: input.fromdate,
      todate: input.todate
    }

    this.rateUploadService.awbExistsInRatePeriod(reqobj).subscribe(res => {
      try {
        if (res && res.success && res.data?.isExists) {
          this.applyRates(input.fromdate, input.todate);
        }
      } catch (error) {
        console.error(error);
      }
    });
  }

  bindRateInfo(ratePeriodId: any) {
    this.rowDataInfo = [];
    this.ratePeriodId = ratePeriodId;
    this.rateUploadService.GetRateInfoByPeriod(ratePeriodId).subscribe(res => {
      try {
        this.ngxLoaderService.start();
        if (res) {
          this.ngxLoaderService.stop();
          this.rowDataInfo = res.data;
          if (res.data.length) {
            this.rowDataInfo = res.data;
            this.showRateDetails = true;
          } else {
            this.showRateDetails = false;
            this.appCoreService.showMessage('No rate information avialable', 'Opps !', 'warning');
          }
        }
      } catch (error) {
        this.ngxLoaderService.stop();
        console.error(error);
      }
    })
  }

  onGridReadyPeriod(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
  }

  editAction(cell: any) {
    try {
      if (!this.permConfig.isEditAllowed) {
        this.warningDialog('No Access to Edit.')
      }
      else if (this.permConfig.isEditAllowed && cell) {
        //find the cell in rowData List
        const rateDetailData = this.rowDataInfo.find(item => item.id === cell.id);
        this.openRateDetail(rateDetailData);
      }
    } catch (e) {
      console.error(e);
    }

  }

  openRateDetail(data) {
    const modalRef = this.modalService.open(RateDetailsComponent, this.ngbModalOptions);
    modalRef.componentInstance.data = data;
    modalRef.result.then(
      (result) => {
        if (result) {
          // console.log('Closed with: result', result);
          this.appCoreService.showMessage('Record Updated Successfully.', 'Success', 'success')
          this.bindRateInfo(this.ratePeriodId);
        }
      },
      (reason) => {
        // console.log('Dismissed reason', reason);
        if (reason == 'Cross click') {
          // this.bindList();
        }
      }
    );
  }
  openRatePeriod(data) {
    const modalRef = this.modalService.open(RatePeriodComponent, this.ngbModalOptions);
    modalRef.componentInstance.data = data;
    modalRef.componentInstance.rateTypes = this.rateTypeList;
    modalRef.result.then(
      (result) => {
        if (result) {
          // console.log('Closed with: result', result);
          this.appCoreService.showMessage('Record Updated Successfully.', 'Success', 'success')
          this.getAllRatePeriod(true);
        }
      },
      (reason) => {
        // console.log('Dismissed reason', reason);
        if (reason == 'Cross click') {
          // this.bindList();
        }
      }
    );
  }

  editPeriodAction(cell: any) {
    try {
      if (!this.permConfig.isEditAllowed) {
        this.warningDialog('No Access to Edit.')
      }
      else if (this.permConfig.isEditAllowed && cell) {
        this.rateService.GetRatePeriodByTypeId(cell.id).subscribe(res => {
          if (res?.success) {
            this.openRatePeriod(res.data[0]);
          }
        })
      }
    } catch (e) {
      console.error(e);
    }

  }

  viewAction(cell: any) {
    if (!this.permConfig.isViewAllowed) {
      this.warningDialog('No Access to View.');
    }
    else if (this.permConfig.isViewAllowed && cell) {
      this.periodId = cell.id;
      this.bindRateInfo(this.periodId);
    }
  }

  async deletePeriodAction(cell: any) {
    if (!this.permConfig.isDeleteAllowed) {
      this.warningDialog('No Access to Delete.');
    }
    else if (cell && cell.id && this.permConfig.isDeleteAllowed) {
      const confirmed = await this.openConfirmationDialog();
      if (confirmed) {
        this.ngxLoaderService.start();
        this.rateUploadService.DeleteRatePeriodById(cell.id).subscribe(res => {
          try {
            if (res && res.success) {
              this.ngxLoaderService.stop();
              this.appCoreService.showMessage('Record deleted successfully.', 'Success', 'success');
              this.getAllRatePeriod(true);
            } else if (res && res.success) {
              this.ngxLoaderService.stop();
            }
          } catch (error) {
            console.error(error);
            this.ngxLoaderService.stop();
          }
        });
      }
    }
  }

  async deleteAction(cell: any) {
    if (!this.permConfig.isDeleteAllowed) {
      this.warningDialog('No Access to Delete.');
    }
    else if (this.permConfig.isDeleteAllowed && cell && cell.id) {
      const confirmed = await this.openConfirmationDialog();
      if (confirmed) {
        this.ngxLoaderService.start();
        this.rateUploadService.DeleteRateInfoById(cell.id).subscribe(res => {
          try {
            if (res && res.success) {
              this.ngxLoaderService.stop();
              this.appCoreService.showMessage('Record deleted successfully.', 'Success', 'success');
              this.bindRateInfo(this.periodId);
            } else if (res && res.succes) {
              this.ngxLoaderService.stop();
            }
          } catch (error) {
            console.error(error);
            this.ngxLoaderService.stop();
          }
        });
      }
    }
  }

  onUpdatePeriod(e: any) {
    this.showPeriodModal = false;
    this.getAllRatePeriod(true);
  }

  onUpdateRateDetails(e: any) {
    this.showRateModal = false;
    this.bindRateInfo(this.periodId);
  }

  async invalidPeriodDialog(msg: string) {
    const result = await Swal.fire({
      titleText: 'Error',
      html: msg,
      icon: 'error',
      // confirmButtonText: 'Yes',
      // showDenyButton: true,
      // denyButtonText: 'No',
      allowEscapeKey: false,
      allowOutsideClick: false
    });

    if (result.isConfirmed) {
      return false;
    }
  }

  async openConfirmationDialog() {
    const result = await Swal.fire({
      titleText: 'Confirmation',
      text: "This action is irreversible. Are you sure you want to delete?",
      icon: 'warning',
      confirmButtonText: 'Yes',
      showDenyButton: true,
      denyButtonText: 'No',
      allowEscapeKey: false,
      allowOutsideClick: false
    });
    if (result.isConfirmed) {
      return true;
    }
  }

  async successDialog(msg?: any) {
    const success = await Swal.fire({
      titleText: 'Success',
      text: msg,
      icon: 'success',
      confirmButtonText: 'Ok',
      allowEscapeKey: false,
      allowOutsideClick: false
    })
    if (success.isConfirmed) {
      // this.getAllRatePeriod();
      this.isFormSubmitted = false;
      this.rateUploadForm.reset();
      this.rateUploadForm.controls.txtFromDate.setValue(this.currentDate.dateString);
      this.rateUploadForm.controls.txtToDate.setValue(this.currentDate.dateString);
    }
  }

  async warningDialog(msg?: any) {
    Swal.fire({
      titleText: 'Warning',
      text: msg,
      icon: 'warning',
      confirmButtonText: 'Ok',
      allowEscapeKey: false,
      allowOutsideClick: false
    })
  }

  async applyRates(fromdate, todate) {
    const result = await Swal.fire({
      title: 'Confirmation !',
      html: "<span>Do you want to update</span><b> Rates </b><span>in mentioned period ?</span>",
      icon: 'warning',
      confirmButtonText: 'Yes',
      showDenyButton: true,
      denyButtonText: 'No',
    });

    if (result.isConfirmed) {
      let req = {
        fromdate: fromdate,
        todate: todate,
        rateupdatetype: "Customer"
      }
      this.rateService.UpdateRates(req).subscribe(res => {
        //console.log(res);
        if (res && res.success) {
          this.appCoreService.showMessage('Rates Applied Successfully.', 'Success', 'success');
        }
      });
    }

    this.isFormSubmitted = false;
    this.rateUploadForm.reset();
    this.rateUploadForm.controls.txtFromDate.setValue(this.currentDate.dateString);
    this.rateUploadForm.controls.txtToDate.setValue(this.currentDate.dateString);
  }

  async warningExcelDialog(msg: any, data: []) {
    const isHtml = msg.includes('<') && msg.includes('>');
    const confirmText = isHtml ? '<i class="bx bx-download"></li> Download' : null;
    const res = await Swal.fire({
      title: 'Warning!',
      [isHtml ? 'html' : 'text']: msg,
      icon: 'warning',
      confirmButtonText: confirmText,
      showCloseButton: true,
      showConfirmButton: isHtml,
      allowEscapeKey: false,
      allowOutsideClick: false
    });
    if (res.isConfirmed) {
      data?.length ? this.excelService.exportAsExcelFile(data, "Rates_Import_Errors") : null;
    }
  }
}